export interface DepotOpeningHours {
  times: string;
  weekday: string;
}

export interface CarSearchResponse {
  search_reference_id: string;
  fallback_thumb_image_url: string;
  results: Array<CarSearchResult>;
}

export interface CarSearchResult {
  air_conditioning: boolean;
  baggage_capacity: number;
  booking_token: string;
  car_description: string;
  car_category_ids: Array<number>;
  hero_image_url: string;
  thumb_image_url: string;
  end_date_full: string;
  end_location: CarDeppoLocation;
  end_location_id: string;
  end_location_city: string;
  end_location_name: string;
  end_location_opening_hours: DepotOpeningHours[];
  included_in_rate: Array<string>;
  mileage_allowance: number;
  num_doors: number;
  pax_capacity: number;
  price_per_day: {
    amount: string;
    currency_code: string;
  };
  start_date_full: string;
  start_location: CarDeppoLocation;
  start_location_id: string;
  start_location_city: string;
  start_location_name: string;
  start_location_opening_hours: DepotOpeningHours[];
  supplier_name: string;
  source?: string;
  total_price: {
    amount: string;
    currency_code: string;
  };
  transmission: {
    type: CarTransmissionType;
    display_text: CarTransmissionType;
  };
  fallbackThumbImageUrl: string;
  isBooking: boolean;
  instalment_payments_available: boolean;
}

export interface CarDeppoLocation {
  depot_id: number;
  name: string;
  longitude: string;
  latitude: string;
  opening_times: any;
  depot_name: string;
  address1: string;
  city: string;
  postcode: string;
  phone: string;
  tp_depot_id: string;
}

export enum CarTransmissionType {
  AUTOMATIC = 'Automatic',
  MANUAL = 'Manual',
}
